import ArticleListing from './article-listing'
export default
	name: 'RecipeListing'

	functional: true

	render: (create, {data}) ->
		data = {
			...data
			props:
				isRecipeBlock: true
		}

		create ArticleListing, data
